export default __webpack_public_path__ + "static/media/advantagesharpenedweapons.a314ee18.png";